<template>
    <template v-for="(part, index) in parts" :key="index">
        <br v-if="part.type === 'br'" />
        <CompassLink
            v-else-if="part.type === 'link'"
            :label="part.label"
            :link="part.url"
            target="_blank"
        />
        <span v-else>{{ part.content }}</span>
    </template>
</template>

<script setup lang="ts">
import type { TranslationPart } from 'composables/useTranslationLinkParser';

defineProps<{
    parts: TranslationPart[];
}>();
</script>
